<script setup lang="ts">
  import { useMapToHero } from '@/domains/investor/composables/useMapToHero'
  import { useReportPage } from '@/domains/investor/composables/useReportPage'
  import useReportPageHead from '@/domains/investor/composables/useReportPageHead'
  import InvestorHero from '@/domains/investor/components/Hero/Hero.vue'
  import InvestorArticle from '@/domains/investor/components/Article/Article.vue'
  import InvestorFiles from '@/domains/investor/components/Files/Files.vue'
  import type { IProps as IHeroProps } from '@/domains/investor/components/Hero/Hero.types'
  import { formatDate } from '@/utils/date'

  definePageMeta({
    layout: 'investor',
  })

  const showReport = ref(false)
  const heroData = ref<IHeroProps>()
  const { getReport } = await useReportPage()
  const response = await getReport()
  const report = response.data.value

  if (response.data.value) {
    showReport.value = true
    heroData.value = useMapToHero(response.data.value)
    const { title, link, meta, I18nParams } = useReportPageHead(response.data.value)
    const setI18nParams = useSetI18nParams()
    setI18nParams(I18nParams)
    useHead({
      title,
      meta,
      link,
    })
  }
  else {
  throw createError({
    statusCode: 400,
    fatal: true,
  })
}

</script>

<template>
  <div class="articlePage">
    <div
      v-if="!showReport || !report"
      class="articlePage__loader"
    >
      <Loader />
    </div>

    <div
      v-if="showReport && report"
    >
      <InvestorHero
        :image="heroData!.image"
        :title="heroData!.title"
        :lead="heroData!.lead"
        :first-button="heroData?.firstButton"
        :main-category="heroData?.mainCategory"
        :second-category="heroData?.secondCategory"
      />

      <InvestorArticle
        :content="report.content"
        :title="report.title"
        :date="formatDate(report.date, 'DD/MM/YYYY')"
      >
        <InvestorFiles
          v-if="report.files.length > 0"
          :files="report.files"
        />
      </InvestorArticle>

    </div>
  </div>
</template>

<style lang="scss" scoped>
.articlePage {
  margin: 0 auto;
  
  &__loader {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: calc(100vh - 8.8rem);
  }
  
  &__content {
    padding: 8.8rem 2.4rem 4.8rem 2.4rem;
  }
}
</style>
